import { Locale } from "@obs/providers";
import { useQueryClient } from "@tanstack/react-query";
import { useEffect, useRef } from "react";

/**
 * Clears React Query cache when locale changes (but not on initial mount).
 * This ensures API calls are re-fetched with the new locale header.
 */
export const useLocaleCacheInvalidator = () => {
	const { locale } = Locale.useLocale();
	const queryClient = useQueryClient();
	const previousLocaleRef = useRef(locale);

	useEffect(() => {
		if (locale && previousLocaleRef.current !== locale) {
			queryClient.invalidateQueries();
		}
		previousLocaleRef.current = locale;
	}, [locale]);
};
